import { Button, Modal } from 'antd';
import CheckCircleFill2Icon from 'assets/icons/check-circle-fill-2.svg';

interface props {
    open: boolean;
    onCancel: () => void | Promise<void>;
    onOk: () => void | Promise<void>;
}

export const ConfirmModalComponent = ({ open, onCancel, onOk }: props) => {
    return (
        <Modal width={327} open={open} footer={null} centered className="modal-info">
            <section style={{ paddingTop: 12, paddingBottom: 4 }}>
                <div style={{ width: '100%' }} className="center-inside">
                    <img src={CheckCircleFill2Icon} alt="" />
                </div>
                <div className="confirm-modal-2-title" style={{ marginBottom: 8, marginTop: 32 }}>
                    出品価格を登録しました
                </div>
                <div
                    className="confirm-modal-2-description"
                    style={{ marginBottom: 32, color: '' }}
                >
                    運営による最終確認後に掲載されます。
                    <br />
                    <br />
                    また、取引に関する詳細説明を希望しますか？
                    <br />
                    希望される方には後日、ご連絡差し上げます。
                </div>

                <Button
                    type="primary"
                    className="button-login-text"
                    style={{ width: '100%', height: 48, marginBottom: 12 }}
                    onClick={() => onOk()}
                >
                    希望する
                </Button>
                <Button
                    type="link"
                    block
                    className="text-button-cancel"
                    style={{ width: '100%', height: 48 }}
                    onClick={() => onCancel()}
                >
                    希望しない
                </Button>
            </section>
        </Modal>
    );
};
